import { render, staticRenderFns } from "./ReportRegistrationChart.vue?vue&type=template&id=a3fb24ea&"
import script from "./ReportRegistrationChart.vue?vue&type=script&lang=ts&"
export * from "./ReportRegistrationChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports